import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { deleteEntity, updateEntities } from 'redux-modules/entity'
import api from 'api'

const CREATE_REQUEST = 'realhub/publicationOption/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/publicationOption/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/publicationOption/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/publicationOption/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/publicationOption/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/publicationOption/UPDATE_FAILURE'
const DELETE_REQUEST = 'realhub/publicationOption/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/publicationOption/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/publicationOption/DELETE_FAILURE'

// Initial State
const initialState = {
  result: [],
  creating: false,
  deleting: false,
  errors: [],
  updating: false,
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function deletePublicationOption(option, options){
  const config = {
    method: 'DELETE',
  }
  return (dispatch, getState) => {
    // Set Loading
    dispatch(deleteRequest())
    const url = `/admin/publications/${option.publication_id}/options/${option.id}.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        const state = getState()

        // Remove the option from the publication
        const publicationEntity = Object.assign({}, state.entities.publications[option.publication_id])
        const optionIndex = publicationEntity.publication_options.indexOf(option.id)
        publicationEntity.publication_options.splice(optionIndex, 1)
        dispatch(updateEntities(normalize(publicationEntity, Schemas.PUBLICATION)))

        // Remove the option to the result array
        const publicationOptionArray = state.publicationOptions.result ? state.publicationOptions.result.slice() : []
        const index = publicationOptionArray.indexOf(option.id)
        const x = normalize(option, Schemas.PUBLICATION_OPTION)
        dispatch(deleteEntity(x))

        // Remove the entity
        if (index != -1){
          publicationOptionArray.splice(index, 1)
          dispatch(deleteSuccess({ result: publicationOptionArray }))
        }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })
    return promise
  }
}

export function createPublicationOption(option, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      publication_option: option,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/admin/publications/${option.publication_id}/options.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const resultArray = getState().publicationOptions.result ? getState().publicationOptions.result.slice() : []
        if (!resultArray.includes(json.id)){
          resultArray.push(json.id)
        }

        const normalizedJson = normalize(json, Schemas.PUBLICATION_OPTION)
        const publications = Object.assign({}, getState().entities.publications)
        if (publications[option.publication_id]){
          const publication = publications[option.publication_id]
          publication.publication_options.push(json.id)
          dispatch(updateEntities(normalize(publication, Schemas.PUBLICATION)))
        }
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess({ result: resultArray }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function updatePublicationOption(option, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      publication_option: option,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/publications/${option.publication_id}/options/${option.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PUBLICATION_OPTION)

        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        result: action.result,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        result: action.result,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
